import { useRef } from "react";

export default function StaffPhotoGalleryLink({rtl,disabled,onFile}:{rtl:boolean;disabled:boolean;onFile:(file:File)=>void}){
  const input=useRef<HTMLInputElement>(null),label=rtl?"أو اختر من معرض الصور":"or choose from gallery";
  return <><input ref={input} type="file" hidden accept="image/jpeg,image/png,image/webp" disabled={disabled} aria-label={label} onChange={e=>{const file=e.target.files?.[0];e.target.value="";if(file&&!disabled)onFile(file)}}/><button type="button" className="staff-photo-gallery" disabled={disabled} onClick={()=>input.current?.click()}>{label}</button></>;
}
